<template>
  <div class="tooltip-container">
    <slot></slot>

    <div class="tooltip-box hidden-xs-down"
         v-bind:class="classBindings"
         v-if="showTooltip">
      <div class="tooltip-pointer"></div>

      <div class="tooltip-body text-center">
        <slot name="tooltip-body">
          <div class="typography--body-3 typography--color-secondary">hello</div>
          <div class="typography--body-3 typography--color-secondary">world</div>
        </slot>
      </div>

      <div class="tooltip-action">
        <img src="/static/images/icon-close-tooltip.svg"
             class="close-tooltip clickable"
             v-on:click="close">
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'tooltip',

    props: [
      'position',
      'show',
    ],

    data() {
      return {
        closed: false,
      };
    },

    computed: {
      showTooltip() {
        return this.show && !this.closed;
      },

      classBindings() {
        return {
          'tooltip-top': this.position === 'top',
          'tooltip-bottom': this.position === 'bottom',
          'tooltip-left': this.position === 'left',
          'tooltip-right': this.position === 'right',
        };
      },
    },

    methods: {
      close() {
        this.closed = true;
        this.$emit('tooltip-closed');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Tooltip.vue